
import { useEffect } from 'react';

const TitleOnly = ({ title, description }) => {

    useEffect(() => {
        document.title = `${title} | Kingsley Bate`;

        // Update meta description if provided
        if (description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = 'description';
                document.head.appendChild(metaDescription);
            }
            metaDescription.content = description;
        }
    }, [title, description]);

    return null;
}

export default TitleOnly;

